export const FETCH_CAMPAIGN_FILE = 'CAMPAIGN_FILE/FETCH_REQUEST';
export const FETCH_CAMPAIGN_FILE_SUCCESS = 'CAMPAIGN_FILE/FETCH_SUCCESS';

export const FETCH_CAMPAIGN_FILES = 'CAMPAIGN_FILES/FETCH_REQUEST';
export const FETCH_CAMPAIGN_FILES_SUCCESS = 'CAMPAIGN_FILES/FETCH_SUCCESS';
export const FETCH_CAMPAIGN_FILES_FAILURE = 'CAMPAIGN_FILES/FETCH_FAILURE';

export const PATCH_CAMPAIGN_FILE = 'CAMPAIGN_FILES/PATCH_REQUEST';
export const PATCH_CAMPAIGN_FILE_SUCCESS = 'CAMPAIGN_FILES/PATCH_SUCCESS';
export const PATCH_CAMPAIGN_FILE_FAILURE = 'CAMPAIGN_FILES/PATCH_FAILURE';

/** CAMPAIGN FILES FILTERS */
export const SET_CAMPAIGN_FILES_FILTER = 'CAMPAIGN_FILES/FILTERS/SET_ONE';
export const SET_CAMPAIGN_FILES_FILTERS = 'CAMPAIGN_FILES/FILTERS/SET_MANY';
export const REMOVE_CAMPAIGN_FILES_FILTER = 'CAMPAIGN_FILES/FILTERS/REMOVE_ONE';
export const CLEAR_CAMPAIGN_FILES_FILTER = 'CAMPAIGN_FILES/FILTERS/CLEAR';

export const OPEN_DETAILS_DRAWER = 'CAMPAIGN_FILE/DETAILS/DRAWER/OPEN';
export const CLOSE_DETAILS_DRAWER = 'CAMPAIGN_FILE/DETAILS/DRAWER/CLOSE';

export const OPEN_CREATION_MODAL = 'CAMPAIGN_FILES/OPEN_CREATION_MODAL';
export const CLOSE_CREATION_MODAL = 'CAMPAIGN_FILES/CLOSE_CREATION_MODAL';

export const CREATE_FILE = 'CAMPAIGN_FILES/CREATE_FILE_REQUEST';
export const CREATE_FILE_SUCCESS = 'CAMPAIGN_FILES/CREATE_FILE_SUCCESS';
export const CREATE_FILE_FAILURE = 'CAMPAIGN_FILES/CREATE_FILE_FAILURE';

export const CREATE_BULK_FILES = 'CAMPAIGN_FILES/CREATE_BULK_FILES_REQUEST';
export const CREATE_BULK_FILES_SUCCESS = 'CAMPAIGN_FILES/CREATE_BULK_FILES_SUCCESS';
export const CREATE_BULK_FILES_FAILURE = 'CAMPAIGN_FILES/CREATE_BULK_FILES_FAILURE';

/** BULK FILTERS */
export const SET_CAMPAIGN_FILES_BULK_FILTER = 'CAMPAIGN_FILES/FILTERS/BULK/SET_ONE';
export const REMOVE_CAMPAIGN_FILES_BULK_FILTER = 'CAMPAIGN_FILES/FILTERS/BULK/REMOVE_ONE';
export const CLEAR_CAMPAIGN_FILES_BULK_FILTER = 'CAMPAIGN_FILES/FILTERS/BULK/CLEAR';
export const IMPORT_CAMPAIGN_FILES_BULK_FILTER = 'CAMPAIGN_FILES/IMPORT_CAMPAIGN_FILES_FILTERS_IN_BULK';

export const APPROVE_MANUALLY_REQUEST = 'CAMPAIGN_FILES/APPROVE_MANUALLY/REQUEST';
export const APPROVE_MANUALLY_SUCCESS = 'CAMPAIGN_FILES/APPROVE_MANUALLY/SUCCESS';

export const CREATE_CHECKLISTS_REQUEST = 'CAMPAIGN_FILES/CREATE_CHECKLISTS/REQUEST';
export const CREATE_CHECKLISTS_SUCCESS = 'CAMPAIGN_FILES/CREATE_CHECKLISTS/SUCCESS';

export const FETCH_FILTERED_CAMPAIGN_FILES = 'CAMPAIGN_FILES/FILTER/FETCH_REQUEST';
export const FETCH_FILTERED_CAMPAIGN_FILES_SUCCESS = 'CAMPAIGN_FILES/FILTER/FETCH_SUCCESS';
export const FETCH_FILTERED_CAMPAIGN_FILES_FAILURE = 'CAMPAIGN_FILES/FILTER/FETCH_FAILURE';
